export function pathMatches(route, pathname) {
  if (!route) return true;
  const path = pathname || "/";
  return path === route || path.startsWith(`${route}/`);
}
